import { Box, Card, Text } from 'grommet';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import modNumeration from '../functions/modNumeration';

// import {BookInfo} from "../config/types";

const NumeroListUnit = (props: any) => {

  const listUnit = props.numeroinfo
  let unitTitle = listUnit.book_title
  unitTitle = unitTitle.replace("月末 現在 基準", "月末 基準");
  let unitNumber = listUnit.numeration
  unitNumber = unitNumber.replace("月末 現在 基準", "月末 基準");
  unitNumber = unitNumber.replace("月末現在 基準", "月末 基準");

  const cat = props.cat
  // console.log("book list unit", listUnit)

  let navigate= useNavigate()

  const gotoNumero = (nid:string) => {
    let address = "/archive/" + cat + "book#" + nid;
    console.log(address)
    navigate(address)
  }

  return (
    <Card width="full" height="full" align="center" justify="center"
      pad={{ horizontal: "10px" }} round="0"
      background="rgb(255,255,255,0.8)"
      focusIndicator={false}
      onClick={()=>gotoNumero(listUnit.book_id)}
    >
      <Box direction="row" wrap align="end" justify="start">
        {listUnit.authors!==null && listUnit.authors.length > 0 &&
          <Text size="14px" margin="1px">{listUnit.authors}. </Text>}
        <Text size="14px" margin="1px">{unitTitle}.</Text>
        <Text size="16px" margin={{vertical:"1px", horizontal: "10px"}}
          weight="bold">{modNumeration(unitNumber)}</Text>
        <Text size="14px" margin="1px">{listUnit.publisher}.</Text>
        <Text size="14px" margin="1px">{listUnit.publish_year}.</Text>

      </Box>

    </Card>
  )
}

export default NumeroListUnit;